"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asynchronousRules = void 0;
const validateUrlSelectValue_1 = require("./validateUrlSelectValue");
const validateAvailableItems_1 = require("./validateAvailableItems");
// These are the validations that are asynchronouse (e.g. require fetch
exports.asynchronousRules = [
    validateUrlSelectValue_1.validateUrlSelectValueInfo,
    validateAvailableItems_1.validateAvailableItemsInfo,
];
